module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('strong', [_c('em', [_vm._v("Contents")])])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005_Editorspreface#fm-1"
    }
  }, [_c('em', [_vm._v("Editor’s Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Authorspreface#fm-2"
    }
  }, [_c('em', [_vm._v("Author’s Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Abbreviations#fm-3"
    }
  }, [_c('em', [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Textsandtranslations#fm-4"
    }
  }, [_c('em', [_vm._v("Texts and Translations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01#pt-1"
    }
  }, [_c('strong', [_vm._v("THE LETTER TO THE COLOSSIANS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Bibliography#sec2-1"
    }
  }, [_vm._v("Select Bibliography on Colossians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Bibliography#sec2-2"
    }
  }, [_c('em', [_vm._v("Commentaries")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Bibliography#sec2-3"
    }
  }, [_c('em', [_vm._v("Other Works")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#ch-1"
    }
  }, [_vm._v("INTRODUCTION TO COLOSSIANS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-1"
    }
  }, [_vm._v("I. To Whom Was Colossians Written? Colossae and the Colossians")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.3em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-2"
    }
  }, [_vm._v("II. Who Wrote the Letter? Authorship")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-3"
    }
  }, [_vm._v("III. When Was the Letter Written? Date and Place of Writing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-4"
    }
  }, [_vm._v("IV. Why Was Colossians Written? The False Teaching")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.4em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-5"
    }
  }, [_vm._v("V. What Is Colossians Teaching? The Theology of the Letter")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec2-4"
    }
  }, [_vm._v("A. Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec2-5"
    }
  }, [_vm._v("B. Cosmology and the Powers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec2-6"
    }
  }, [_vm._v("C. The Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec2-7"
    }
  }, [_vm._v("D. The Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec2-8"
    }
  }, [_vm._v("E. Eschatology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec2-9"
    }
  }, [_vm._v("F. The Christian Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COMMENTARY ON COLOSSIANS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. The Letter Opening: “Just as You Have Received Christ Jesus as Lord …” (1:1–2:5)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec2-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Prescript (1:1-2)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec2-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. The Powerful Gospel of God’s Son (1:3-23)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec3-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. The Evidence of the Gospel’s Power among the Colossians (Thanksgiving and Prayer) (1:3-14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec3-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. The Heart of the Gospel: The Supremacy of Christ in Creation and Redemption (1:15-20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec3-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. The Hope Held Out in the Gospel (1:21-23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec2-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. The Mystery of Christ in Paul’s Ministry and Christian Experience (1:24–2:5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.3em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter02b#sec-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. The Letter Body: “… Continue to Live Your Lives in Him” (2:6–4:6)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter02b#sec2-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. The Heart of the Matter: Remaining Centered on Christ (2:6-7)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter02b#sec2-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. The Threat to Christocentric Living: Warning about False Teachers (2:8-23)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter02b#sec3-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Spiritual Fullness in Christ (2:8-15)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter02b#sec3-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. The Empty Promise of the False Teaching (2:16-23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter02c#sec2-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Living a Christocentric Life (3:1–4:1)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter02c#sec3-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Heavenly Thinking (3:1-4)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter02c#sec3-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Putting Off the Practices of the “Old Self” (3:5-11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter02c#sec3-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Putting On the Practices of the “New Self” (3:12-17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter02c#sec3-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. The Lordship of Christ in Earthly Relationships (3:18–4:1)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter02c#sec2-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. Exhortation to Prayer and Christian Witness (4:2-6)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter02d#sec-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. The Letter Closing, Greetings, Plans, and Instructions (4:7-18)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/017_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("THE LETTER TO PHILEMON")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Bibliography#sec2-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Select Bibliography on Philemon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Bibliography#sec2-18",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Commentaries")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Bibliography#sec2-19",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Other Works")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTRODUCTION TO PHILEMON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter03#sec-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. A Basic Profile: Author, Recipient, Nature, and Place of Writing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.3em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter03#sec-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. The Situation behind the Letter")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter03#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. The Purpose and Significance of the Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COMMENTARY ON PHILEMON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter04#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. The Letter Opening (vv. 1-3)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.3em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter04#sec-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Thanksgiving: The “Fellowship of Faith” (vv. 4-7)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter04#sec-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. The Letter Body: Paul’s Appeal concerning Onesimus (vv. 8-20)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter04#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. The Letter Closing (vv. 21-25)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ecb6352","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_Contents.vue
// module id = 66
// module chunks = 0